module.exports = {"340303001":"天桥街道","340303002":"青年街道","340303003":"纬二路街道","340303004":"黄庄街道","340303005":"宏业村街道","340303200":"燕山乡","340303201":"雪华乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340303.json
// module id = 1058
// module chunks = 0